import { render, staticRenderFns } from "./TransferBatchModal.vue?vue&type=template&id=cdd2da66&lang=pug&"
import script from "./TransferBatchModal.vue?vue&type=script&lang=js&"
export * from "./TransferBatchModal.vue?vue&type=script&lang=js&"
import style0 from "./TransferBatchModal.vue?vue&type=style&index=0&id=cdd2da66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports